import Vue from 'vue'
import { $ } from '../_utils'

Vue.component('Pagination', {
  template: '#vue-pagination-template',
  props: ['items', 'total', 'category', 'base-url', 'active'],
  data() {
    return {
      nextLink: '',
      previousLink: '',
      links: [],
    }
  },
  methods: {
    generateUrlLink(item) {
      if (item === 1) {
        return this.$props.category
          ? `${this.$props.baseUrl}artykuly/${this.$props.category}/`
          : `${this.$props.baseUrl}artykuly/`
      }

      return this.$props.category
        ? `${this.$props.baseUrl}artykuly/${this.$props.category}/${item}/`
        : `${this.$props.baseUrl}artykuly/${item}/`
    },
    generateLinks() {
      return this.$props.items.map(item => {
        const itemLink = this.generateUrlLink(item)
        return itemLink
      })
    },
    generateItems() {
      return this.generateLinks().map((link, index) => ({
        url: link,
        number: this.$props.items[index],
      }))
    },
    generateNavLinks() {
      const first = parseInt(this.$props.items[0])
      const last = parseInt(this.$props.items.length)
      const total = parseInt(this.$props.total)
      const previous = first === 1 ? null : parseInt(this.$props.items[0]) - 1
      const next =
        parseInt(this.$props.items[last - 1]) === total
          ? null
          : parseInt(this.$props.items[last - 1]) + 1

      previous ? (this.previousLink = this.generateUrlLink(previous)) : (this.previousLink = '')
      next ? (this.nextLink = this.generateUrlLink(next)) : (this.nextLink = '')
    },
  },
  mounted() {
    this.links = this.generateItems()
    this.generateNavLinks()
  },
})

const pagination = $('#vue-pagination-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!pagination) return
  new Vue({
    el: '#vue-pagination-wrapper',
  })
})
